import { User } from '../pages/UserProfile/userProfileSlice';

interface Member {
  user?: User;
}

export default function sortMembers<T extends Member>(members: T[]) {
  const existingUsers = [];
  const removedUsers = [];
  for (let i = 0; i < members.length; i++) {
    const member = members[i];
    if (member.user) {
      existingUsers.push(member);
    } else {
      removedUsers.push(member);
    }
  }
  existingUsers.sort((a, b) => {
    const nameA = `${a.user?.firstName.toUpperCase()}${a.user?.lastName.toUpperCase()}`; // ignore upper and lowercase
    const nameB = `${b.user?.firstName.toUpperCase()}${b.user?.lastName.toUpperCase()}`; // ignore upper and lowercase
    return nameA.localeCompare(nameB);
  });
  return [...removedUsers, ...existingUsers];
}
